module.exports = __webpack_public_path__ + "img/slide-2.a8dafe90.webp";